import React, { useState } from "react";
import { useTable, usePagination } from "react-table";
import Cards from "../Cards";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import DropdownSearch from "../../../../components/DropdownSearch";
import download_icon from "../../../../assets/vw/svg/download.svg";
import filtro_icon from "../../../../assets/vw/svg/filtro.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import InputDate from "../../../../components/InputDate";
import null_icono from "../../../../assets/vw/svg/null.svg";

import { formatearFecha } from "../../../../utils/fecha";

const filtroTransaccionInicial = {
  app: "",
  metodo: "",
  fechaDesde:  "",
  fechaHasta: "",
  contar: false,
};

function Table({
  columns,
  data,
  servicio,
  setQueryParams,
  aplicaciones,
  exportar,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination
  );

  const [modal, setModal] = useState(false);
  const [filtroTransaccion, setFiltroTransaccion] = useState(
    filtroTransaccionInicial
  );
  const [limit, setLimit] = useState(10);
  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const menuhttp = ["GET", "POST", "PUT", "DELETE"];

  const currentYear = new Date().getFullYear();

  const menuYears = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => (currentYear - i));

  const [selectedYear, setSelectedYear] = useState(currentYear);
  
  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  function modalFiltro() {
    setModal(true);
  }

  const handleChangeYear = (newYear) => {
    // Restablecer las fechas en el filtro de transacciones
    setFiltroTransaccion({
      ...filtroTransaccion,
      fechaDesde: "", // Vaciar "Fecha desde"
      fechaHasta: "", // Vaciar "Fecha hasta"
    });
    setSelectedYear(newYear); // Actualizar el año seleccionado
  };

  async function filtrarTransacciones() {
    const queryParams = [];

    const filtros = { ...filtroTransaccion };

    if (filtros.fechaDesde !== "")
      filtros.fechaDesde = localDateTimeToUTC(filtros.fechaDesde);

    if (filtros.fechaHasta !== "")
      filtros.fechaHasta = localDateTimeToUTC(filtros.fechaHasta);

    // Agrega query params que no estén vacíos
    for (const key in filtros) {
      if (filtros.hasOwnProperty(key)) {
        const value = encodeURIComponent(filtros[key]);

        if (value !== "") {
          queryParams.push(`${key}=${value}`);
        }
      }
    }

    const queryParamsString = queryParams.join("&");

    if (queryParamsString === "contar=false") {
      alert("Debe seleccionar al menos un filtro.");
      return;
    }

    setQueryParams(queryParamsString);

    setModal(false);
  }

  function handleChangeExportar(e) {
    exportar();
  }

  const disabled_guardar = () => {
    if (filtroTransaccion.app === "" || filtroTransaccion.metodo === "" || filtroTransaccion.fechaDesde ==="" || filtroTransaccion.fechaHasta === "") {
      return true;
    } else {
      return false;
    }
  };

  const buildPopUp = () => {
    return (
      modal && (<div
        className={`modal modal_vw fade ${modal ? "show" : ""}`}
        id="desarchivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={modal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered transacciones-modal modal_lg_vw">
          <div className="modal-content modal_content-vw transacciones-modal-content p-0 p-lg-2">
            <div className="modal-header modal_header-vw pb-0">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setFiltroTransaccion(filtroTransaccionInicial);
                    setModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className="modal-body mx-3 mx-sm-4 mx-lg-5 p-0 mb-2 mb-sm-4 mb-lg-0">
              <div className="titulo pb-1">Filtrar transacciones</div>
              <div className={"border_vw pb-4"}></div>
              {/* Aplicación */}
              <div className="row p-0 mx-0">
                <DropdownSearch
                  menu={aplicaciones}
                  title={"Aplicación"}
                  defaultValue={filtroTransaccion.app}
                  handleOptionSelected={(e) => {
                    setFiltroTransaccion({
                      ...filtroTransaccion,
                      app: e.props.value,
                    });
                  }}
                  fieldID={'idApp'}
                  fieldToShow={'nombre'}
                />
              </div>

              {/* Método HTTP */}
              <div className="row p-0 mx-0 mt-4">
                <DropdownSearch
                  menu={menuhttp.map((metodo) => (
                    {
                      nombre: metodo,
                    }
                  ))}
                  title={"Método HTTP"}
                  defaultValue={filtroTransaccion.metodo}
                  handleOptionSelected={(e) => {
                    setFiltroTransaccion({
                      ...filtroTransaccion,
                      metodo: e.props.value,
                    });
                  }}
                  fieldID={'nombre'}
                  fieldToShow={'nombre'}
                />
              </div>

              {/* Fechas */}
              <div className="row p-0 mx-0 mt-4 ">
                <div className="col-12 col-sm-3 p-0 mb-3 mb-sm-0 ">

                    <DropdownSearch
                      menu={ menuYears.map((anio) => (
                        {
                          nombre: anio,
                        }
                      ))}
                      title={"Año"}
                      defaultValue={selectedYear}
                      handleOptionSelected={(e) => {
                        handleChangeYear(e.props.value);
                      }}
                      fieldID={'nombre'}
                      fieldToShow={'nombre'}
                    />

                </div>

                <div className="d-flex flex-md-row flex-column col-md-9 px-0 gap-2 gap-md-0">
                  <div className="input-fecha-modal datepicker-container col-md-6 p-0 px-0 pl-md-1 mt-md-0 mt-2">
                    <InputDate
                      inputLabel={"Fecha desde"}
                      id={"fechaDesde"}
                      value = {formatearFecha(filtroTransaccion.fechaDesde)}
                      inputField = {filtroTransaccion.fechaDesde}
                      onChange={(date) => 
                          setFiltroTransaccion({
                          ...filtroTransaccion,
                          fechaDesde: date
                        })
                      }
                      year={selectedYear}
                      disableDatesBefore={filtroTransaccion.fechaHasta}
                    />

                  </div>

                  <div className="input-fecha-modal datepicker-container col-md-6 p-0 py-0 pl-md-1 ">
                    <InputDate
                      inputLabel={"Fecha hasta"}
                      id={"fechaHasta"}
                      value = {formatearFecha(filtroTransaccion.fechaHasta)}
                      inputField = {filtroTransaccion.fechaHasta}
                      onChange={(date) => 
                        setFiltroTransaccion({
                          ...filtroTransaccion,
                          fechaHasta: date
                        })
                      }
                      year={selectedYear}
                      disableDatesAfter={filtroTransaccion.fechaDesde}
                    />
                  </div>
                </div>
                
                
              </div>

              {/* Contar */}
              <div className="d-flex align-items-center flex-row gap-2">
                <input
                  type="checkbox"
                  className="checkbox-round mt-1"
                  id="contar"
                  checked={filtroTransaccion.contar}
                  onChange={(event) => {
                    setFiltroTransaccion({
                      ...filtroTransaccion,
                      contar: event.target.checked,
                    });
                  }}
                />
                <label htmlFor="contar" className="text-general-vw m-0">
                  Contar
                </label>
              </div>
            </div>

            <div className="modal-footer footer_modal_vw d-flex justify-content-center gap-3 mx-2 mx-lg-5 mt-4 mb-4">
              <button
                type="button"
                className="button_vw button_vw--secondary mb-2 order-2 order-sm-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  setFiltroTransaccion(filtroTransaccionInicial);
                }}
              >
                Limpiar
              </button>
              <button
                type="button"
                className="button_vw button_vw--primary mb-2 order-1 order-sm-2"
                data-bs-dismiss="modal"
                onClick={()=>{filtrarTransacciones()}}
                disabled={disabled_guardar()}
              >
                Aplicar filtro
              </button>
            </div>
          </div>
        </div>
      </div>)
    );
  };

  const NavigationControl = () => {
    return (
        <div
            className="btn-group btn-group-controls"
            role="group"
            aria-label="First group"
        >
          <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_before} alt="first"/>
          </button>
          {" "}
          <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={before} alt="before"/>
          </button>
          {" "}
          <div className="num_pagination py-3">
            {pageIndex + 1} de {pageOptions.length}
          </div>
          <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={after} alt="after"/>
          </button>
          {" "}
          <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_after} alt="last"/>
          </button>
          {" "}
        </div>
    );
  }

  return (
      <>
        {data.length === 0 ? (
            <div className="my-4">
              <h5 className="d-flex justify-content-center text-general-vw">
                Da clic en el botón para llenar el formulario y visualizar la
                información:
              </h5>
              <div className="d-flex justify-content-center mt-4">
                <button
                    type="button"
                    className={"button_vw button_vw--primary"}
                    onClick={modalFiltro}
                >
                  <img src={filtro_icon} alt="mas" className="px-2"/>
                  Filtrar
                </button>
              </div>
            </div>
        ) : (
            <>
              <div className="content main-content-container">
                <div className="main-content-actions row m-0 py-2">
                  <div className="col-6  m-0 p-0 ">
                    <div className="d-flex justify-content-left gap-3">
                      <button
                          type="button"
                          className={"button_vw button_vw--primary button_filter_item"}
                          onClick={modalFiltro}
                      >
                        <div className="filter_icon"/>
                        <span className={"ml-2"}>Filtrar</span>
                      </button>

                      <button
                          type="button"
                          className={"button_vw button_vw--descargar-azul button_descargar_item"}
                          onClick={handleChangeExportar}
                      >
                        <img src={download_icon} alt="mas" className="px-2"/>
                        <span>Descargar Excel</span>
                      </button>
                    </div>
                  </div>

                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="">
                        <DropDown
                            menu={limitMostrar}
                            title={limitMostrar[0]}
                            inputField={limit}
                      handleOptionSelected={(e) => {
                        const limitInt = optionLimit(e);
                        setLimit(limitInt);
                        setPageSize(Number(limitInt));
                      }}
                    />
                  </div>
                  <NavigationControl />
                </div>
              </div>
            </div>
          </div>
          <Cards
              page={page}
              aplicaciones={aplicaciones}
              NavigationControl={NavigationControl}
          />
          {/* Tabla */}
          <div 
          className="table-responsive"
          style={{
            overflowY: 'hidden'
          }}
        >
          <table
            {...getTableProps()}
            className={
              "table table-striped table-responsive tabla_contenido_vw"
            }
            id="table-canales"
          >
            <thead className="thead-dark">
              {headerGroups.map((headerGroup) => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="thead__titulo"
                >
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className="tbody-table">
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell, cellId) => {
                      if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "") ) {
                        return (
                          <td key={cellId}><img src={null_icono} alt="sinsoporte"></img></td>
                        );
                      }
                      if (cell.column.id === "fechaCreacion") {
                        return (
                          <td {...cell.getCellProps()}>
                            {localDateTimeToUTC(cell.value)}
                          </td>
                        );
                      }

                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </>
      )}

      {buildPopUp()}
    </>
  );
}

function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Aplicación",
        accessor: "app",
        Cell: ({ value }) => {
          if (value === 0) return "";

          return (
            <span>
              {props.aplicaciones.find((app) => app.idApp === value).nombre}
            </span>
          );
        },
      },
      {
        Header: "Usuario",
        accessor: "usuario",
      },
      {
        Header: "Método",
        accessor: "metodo",
      },
      {
        Header: "Estado",
        accessor: "estado",
      },
      {
        Header: "URL",
        accessor: "url",
      },
      {
        Header: "Fecha de creación",
        accessor: "fechaCreacion",
      },
    ],
    [props.aplicaciones]
  );

  return <Table {...props} columns={columns} />;
}



function localDateTimeToUTC(date) {
  const fechaLocal = new Date(date);

  // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
  const fechaUTC = fechaLocal.toISOString().slice(0, 19).replace("T", " ");

  return fechaUTC;
}

export default Tabla;
